import templateUrl from './feature-main-page-template.html';

export const featureMainPageTemplateComponent = {
    bindings: {
        details: '<',
        slugUrl: '@',
        isSubMenu: '@',
        showEditDeleteButtons: '@',
        menuName: '@',
        menuId: '@',
        onEditOverview: '&',
        onEditSequence: '&',
        onPublishStatus: '&'
    },

    templateUrl,

    controller: class FeatureMainPageTemplateComponent {
        constructor($state, SlugService, ModalService) {
            'ngInject';

            this.$state = $state;
            this.slugService = SlugService;
            this.modalService = ModalService;
        }

        $onInit() {
            this.showAddNewMenuButton = this.menuName === "PublicationsAndDocuments";
        }

        routeSequencePageUrl() {
            const url = this.slugService.getSequencePageURL(this.slugUrl);
            
            this.$state.go('app.dashboard.DynamicMenus', {
                url
            });
        }

        routePublishPageUrl(slug) {
            const url = this.slugService.getPublishPageURL(this.slugUrl);
            
            this.$state.go('app.dashboard.DynamicMenus', {
                url
            });
        }

        openNewMenuAddModal() {
            this.modalService.open({
                backdrop: 'static',
                keyboard: false,
                component: 'newMenuAdd',
                details: {
                    menuName: this.menuName,
                    menuId: this.menuId
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/common/components/feature-main-page-template/feature-main-page-template.component.js